<template>
<div id="contents">
  <div id="players" class="page_contents">
    <div class="page_header">
      <h1 class="page_header_title">
        <img src="../assets/img/players/title.png" width="291" alt="PLAYers" />
        <span>社員紹介</span>
      </h1><!-- .top_sec_title -->
      <div class="page_selector" v-if="categories">
        <h3 v-on:click="show_category_box">{{ select_category_name }}</h3>
        <div v-show="category_box" class="page_selector_box">
          <ul>
            <li v-for="category in categories" :key="category.term_id"><a href="" v-on:click="slect_category" v-bind:data="category.term_id" v-bind:name="category.name">{{ category.name }}</a></li>
          </ul>
        </div><!-- .header_selector_box -->
      </div><!-- .page_header_selector -->
    </div><!-- .page_header -->

    <div id="players_contents">
      <div id="players_index" v-if="main_players">

        <transition-group tag="div" id="players_index_main">


          <div v-for="player in main_players" :key="player.post_id" class="player_card hover">
            <p class="player_index_image_main"><router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}" v-bind:style="{ backgroundImage: 'url(' + player.kv_image + ')' }"></router-link></p>
            <div class="player_card_inner">
              <h3>
                <router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}">
                  <span>{{player.name}}</span>
                  <span>{{player.staff_name_en}}</span>
                </router-link>
              </h3>
              <p class="player_num js-player_num" v-bind:data="player.staff_number"></p><!-- .player_num -->
            </div><!-- .player_card_inner -->
          </div><!-- .player_card -->

        </transition-group><!-- #players_index_main -->

        <div id="players_index_sub" v-if="sub_players">
          <div v-for="player in sub_players" :key="player.post_id" class="player_card hover">
            <p class="player_index_image_sub"><router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}" v-bind:style="{ backgroundImage: 'url(' + player.kv_image + ')' }"></router-link></p>
            <div class="player_card_inner">
              <h3>
                <router-link v-bind:to="{name: 'players_show', params: {id: player.post_id}}">
                  <span>{{player.name}}</span>
                  <span>{{player.staff_name_en}}</span>
                </router-link>
              </h3>
              <p class="player_num js-player_num" v-bind:data="player.staff_number"></p><!-- .player_num -->
            </div><!-- .player_card_inner -->
          </div><!-- .player_card -->
        </div><!-- #players_index_sub -->

      </div><!-- #players_index -->
    </div><!-- #players_contents -->

  </div><!-- #players -->

</div><!-- #contents -->
</template>

<script>
export default {
  name: 'players_index',
  data() {
    return {
      api_url: this.$parent.api_base_url+'/api/players/index.php',
      api_category_url: this.$parent.api_base_url+'/api/players/fetch_category.php',
      category_box: false,
      loading: false,
      categories: null,
      select_category: 0,
      select_category_name: '業種別に見る',
      players: null,
      number_image_src: [
        require("../assets/img/common/n_0.png"),
        require("../assets/img/common/n_1.png"),
        require("../assets/img/common/n_2.png"),
        require("../assets/img/common/n_3.png"),
        require("../assets/img/common/n_4.png"),
        require("../assets/img/common/n_5.png"),
        require("../assets/img/common/n_6.png"),
        require("../assets/img/common/n_7.png"),
        require("../assets/img/common/n_8.png"),
        require("../assets/img/common/n_9.png")
      ],
      error: null
    }
  },
  computed: {
    main_players: function(){
      if(this.players){
        return this.players.slice(0, 4)
      }
    },
    sub_players: function(){
      if(this.players){
        return this.players.slice(4)
      }
    }
  },
  filters: {
    zero_padding: function (value) {
      if (!value) return ''
      return ('0000000000' + value).slice(-3);
    }
  },
  methods: {
    show_category_box(){
      if(!this.category_box){
        this.category_box = true
      }
    },
    slect_category(event){
      const term_id = event.target.getAttribute('data')
      const name = event.target.getAttribute('name')
      this.select_category = term_id
      this.select_category_name = name
      this.fetch_player_list()
      this.category_box = false
      event.preventDefault()
    },
    fetch_category_list(){
      this.$axios
        .get(this.api_category_url)
        .then(response => {
          this.categories = response.data.categories
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.loading = false)
    },
    fetch_player_list(){
      this.$axios
        .get(this.api_url,{
          params: {
            term_id: this.select_category
          }
        })
        .then(response => {
          this.players = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally()
    }
  },
  mounted () {
    this.fetch_category_list()
    var queue = new createjs.LoadQueue(true);
    var manifest = this.number_image_src;
    var fetch_player_list = this.fetch_player_list
    queue.loadManifest(manifest,true);
    queue.addEventListener("complete",function(){
      fetch_player_list()
    });

  },
  updated (){
    //画像の置き換え_main
    var number_image_list = this.number_image_src
    $('.js-player_num').each(function(){
      replaceNumber($(this))
    });
    function replaceNumber($dom){
      $dom.html('');
      var staff_num = $dom.attr('data');
      staff_num = ('0000000000' + staff_num).slice(-3);
      $dom.append('<img src="'+number_image_list[staff_num.charAt(0)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(1)]+'">');
      $dom.append('<img src="'+number_image_list[staff_num.charAt(2)]+'">');
    }//replaceNumber
    this.$emit('page_fade')
  }
}
</script>

<style scoped lang="sass">

  #players_index_main .player_card>p
    position: relative
    width: 575px
    height: 320px
    overflow: hidden
    margin: 0 auto
    img
      position: absolute
      bottom: 0
      left: 0
  #players_index_sub .player_card>p
    position: relative
    width: 367px
    height: 200px
    overflow: hidden
    margin: 0 auto
    img
      position: absolute
      bottom: 0
      left: 0

  .v-enter-active

    transition: all 2s ease

  .v-leave-active
    position: absolute
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0)

  .v-enter, .v-leave-to
    opacity: 0
    position: relative

</style>



// WEBPACK FOOTER //
// src/components/players_index.vue